const HeaderTestIdsScope = {
  DOCUMENT_TREE_HEADER: 'document-tree-header',
};

export const HeaderTestIds = {
  DOCUMENT_TREE_HEADER_GENERATE_BUNDLE_ICON_BUTTON: `${HeaderTestIdsScope.DOCUMENT_TREE_HEADER}.generate-bundle-icon-button`,

  // Header.config - getCheckboxesHeaderConfig
  DOCUMENT_TREE_HEADER_HIDE_EMPTY_CATEGORIES_AND_DOCTYPES_CHECKBOX: `${HeaderTestIdsScope.DOCUMENT_TREE_HEADER}.hide-empty-categories-and-doctypes-checkbox`,
  DOCUMENT_TREE_HEADER_HIDE_DELETED_DOCUMENTS_CHECKBOX: `${HeaderTestIdsScope.DOCUMENT_TREE_HEADER}.hide-deleted-documents-checkbox`,
  DOCUMENT_TREE_HEADER_REJECTED_ONLY_CHIP: `${HeaderTestIdsScope.DOCUMENT_TREE_HEADER}.rejected-only-chip`,
};
